"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAllAssetMarginInfo = exports.useAssetMarginInfo = exports.assetMarginInfoData$ = void 0;
const FutureAPI_1 = require("../../../apis/FutureAPI");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const trade_utils_lib_1 = require("trade_utils_lib");
const react_1 = require("react");
const TimeOut = 60 * 60 * 1000; // 毫秒级一小时
exports.assetMarginInfoData$ = (0, rxjs_1.timer)(0, TimeOut).pipe((0, operators_1.mergeMap)(() => {
    return (0, trade_utils_lib_1.requestWithRetry)(() => {
        return (0, FutureAPI_1.queryAssetsMarginInfo)();
    }, { maxRetryCount: 2 }).pipe((0, operators_1.catchError)((e) => {
        return (0, rxjs_1.of)(null);
    }));
}), (0, operators_1.startWith)(null), (0, operators_1.shareReplay)(1));
// 获取联合保证金配置
const useAssetMarginInfo = (coin, isEnable = true) => {
    const [assetMarginInfo, setAssetMarginInfo] = (0, react_1.useState)(null);
    (0, react_1.useEffect)(() => {
        if (!isEnable) {
            return;
        }
        const sub = exports.assetMarginInfoData$.subscribe({
            next: (v) => {
                const res = v === null || v === void 0 ? void 0 : v.coins.find((e) => e.coin === coin);
                if (res) {
                    setAssetMarginInfo(res);
                }
            },
            error: () => { },
        });
        return () => sub.unsubscribe();
    }, [coin, isEnable]);
    return assetMarginInfo;
};
exports.useAssetMarginInfo = useAssetMarginInfo;
/**获取所有币种的联合保证金配置 */
const useAllAssetMarginInfo = (isEnable = true) => {
    const [assetMarginInfo, setAssetMarginInfo] = (0, react_1.useState)([]);
    (0, react_1.useEffect)(() => {
        if (!isEnable) {
            return;
        }
        const sub = exports.assetMarginInfoData$.subscribe({
            next: (v) => {
                setAssetMarginInfo((v === null || v === void 0 ? void 0 : v.coins) || []);
            },
            error: () => { },
        });
        return () => sub.unsubscribe();
    }, [isEnable]);
    return assetMarginInfo;
};
exports.useAllAssetMarginInfo = useAllAssetMarginInfo;
